import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { IFilters } from '@/pages/Workflow/Workflow.types.ts';
import { APP_VERSION } from '@/const';

type IWorkflowState = {
    filters: IFilters;
    setFilters: (filters: Partial<IFilters>) => void;
    flush: () => void;
};

const initialState = {
    filters: {
        industry: '',
        workflow: '',
        labels: []
    }
};

const useWorkflowStore = create<IWorkflowState>()(
    persist(
        (set) => ({
            ...initialState,
            setFilters: (filters) => {
                set((state) => ({
                    filters: {
                        ...state.filters,
                        ...filters
                    }
                }));
            },
            flush: () => {
                set(initialState);
            }
        }),
        {
            name: 'workflow-store',
            storage: createJSONStorage(() => globalThis.sessionStorage),
            partialize: (state) => state,
            version: APP_VERSION
        }
    )
);

export default useWorkflowStore;
